<template>
	<div>
		<v-container class="container--narrow">
			<v-card>
				<v-card-title>
					<template>
						Uusi opintopistehakemus
					</template>
				</v-card-title>
				<v-divider />
				<v-card-text>
					<SchemaToForm
						ref="studyCreditsForm"
						:debug="false"
						:schema="formSchema"
						:disabled="studyCreditsSaveLoading"
						v-model="studyCreditsFormData"
						@valid="studyCreditsFormValid = true"
						@invalid="studyCreditsFormValid = false"
					/>
				</v-card-text>
				<v-divider />
				<v-card-text>
					Kun opintopistehakemuksesi on valmis, valitse ”TALLENNA”. Muista poistaa rasti ”Opintopistehakemukseni on keskeneräinen” -kohdasta.
				</v-card-text>
				<v-divider />
				<v-card-actions>
					<v-btn
						color="error"
						text
						:disabled="studyCreditsSaveLoading"
						@click="studyCreditsDialogOpen = false"
					>
						Peruuta
					</v-btn>
					<v-spacer />
					<v-btn
						color="success"
						text
						:disabled="studyCreditsSaveLoading || !studyCreditsFormValid"
						:loading="studyCreditsSaveLoading"
						@click="saveStudyCredits"
					>
						Tallenna
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import SchemaToForm from '@/components/SchemaToForm'

export default {
	name: 'StudyCredit',

	components: {
		SchemaToForm,
	},

	props: {
		company: {
			type: Object,
			required: true,
		},

		studyCreditId: {
			type: [Number, String],
			required: true,
		},
	},

	data: () => ({
		studyCredit: null,
		formSchema: {},
		studyCreditsFormData: {},
		studyCreditsFormValid: false,
		studyCreditsSaveLoading: false,
	}),

	computed: {
		...mapState({
			config: state => state.config,
			user: state => state.user,
			companies: state => state.companies,
		}),

		studyCredits () {
			return this.company.opintopistehakemukset || []
		},
	},

	watch: {
		studyCreditsFormData: {
			handler (val) {
				const studyCreditData = this.formSchema.fields.findIndex(item => item.name === 'c_opintopisteet_pvm')

				if(val._has_study_credits_date === true) {
					this.$set(this.formSchema.fields[studyCreditData].props, 'disabled', true)
				}

			},
			deep: true,
		},
	},

	mounted () {
		this.formSchema = JSON.parse(JSON.stringify(this.config.forms.studyCreditsApplication))

		this.loadStudyCredit()

		this.$nextTick(() => {
			this.ready = true
		})
	},

	methods: {
		loadStudyCredit () {
			this.studyCredit = this.studyCredits.find(studyCredit => {
				return studyCredit.id == this.studyCreditId
			})

			if (!this.studyCredit) {
				this.$router.replace({ name: 'Error404' })
			}

			this.studyCreditsFormData = {
				lastname: this.user.lastname,
				firstname: this.user.firstname,
				birthdate: this.user.birthdate,
				email_address: this.user.email_address,
				gender: this.user.gender,
				c_yritys_nimi: this.company.c_yritys_nimi,
				...this.studyCredit,
			}
		},

		saveStudyCredits () {
			this.studyCreditsSaveLoading = true

			this.$api.Companies.doRequest({
				url: 'study-credits',
				method: 'POST',
				body: {
					...this.studyCreditsFormData,
					company_id: this.company.id,
					study_credit_id: this.studyCreditId,
				},
			}).on('done', res => {
				if (!res.body.error) {
					this.$nextTick(() => {
						this.$store.dispatch('clearConfirmNavigation')
						this.$router.replace({
							name: this.$route.matched[this.$route.matched.length - 2].name,
						})
					})
				}
			}).on('finish', () => {
				this.studyCreditsSaveLoading = false
			})
		},

	},

}
</script>
